import React from 'react';
import { useNavigate } from 'react-router-dom';
import apiService from '../../services/ApiService';
import type { HomeFeedSummary, HomeQuickAction } from './homeTypes';

interface HomeQuickActionsRailProps {
  actions: HomeQuickAction[];
}

export const HomeQuickActionsRail: React.FC<HomeQuickActionsRailProps> = ({ actions }) => {
  const navigate = useNavigate();

  if (actions.length === 0) {
    return <p className="text-sm text-gray-500 px-1">Actions appear based on your activity.</p>;
  }

  return (
    <ul className="space-y-0.5 list-none p-0 m-0">
      {actions.map((action) => (
        <li key={action.id}>
          <button
            type="button"
            onClick={() => {
              void apiService.trackEvent('home_feed_quick_action', {
                metadata: { action_id: action.id },
              });
              if (action.web_url) navigate(action.web_url);
            }}
            className={`w-full min-h-[40px] text-left px-3 py-2 rounded-lg text-sm font-medium transition-colors duration-200 cursor-pointer border border-transparent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500/40 ${
              action.emphasis === 'primary'
                ? 'bg-orange-500/[0.1] text-orange-300 hover:bg-orange-500/[0.16]'
                : 'text-gray-300 hover:bg-white/[0.04] hover:text-white'
            }`}
          >
            {action.label}
          </button>
        </li>
      ))}
    </ul>
  );
};

interface HomeSnapshotRailProps {
  summary: HomeFeedSummary;
}

export const HomeSnapshotRail: React.FC<HomeSnapshotRailProps> = ({ summary }) => (
  <dl className="grid grid-cols-2 gap-3 text-sm px-0.5">
    <div>
      <dt className="text-gray-500 text-xs">Events</dt>
      <dd className="stat-numeral text-xl text-white">{summary.counts.events}</dd>
    </div>
    <div>
      <dt className="text-gray-500 text-xs">Passport</dt>
      <dd className="stat-numeral text-xl text-white">{summary.counts.passport}</dd>
    </div>
    <div>
      <dt className="text-gray-500 text-xs">Builds</dt>
      <dd className="stat-numeral text-xl text-white">{summary.counts.builds}</dd>
    </div>
    <div>
      <dt className="text-gray-500 text-xs">Actions</dt>
      <dd className="stat-numeral text-xl text-white">{summary.counts.action_required}</dd>
    </div>
  </dl>
);
